export enum UserGroups {
  internal = 'Internal',
  external = 'External',
  customer = 'Customer',
}
